module.exports = __webpack_public_path__ + "static/img/chenpicha.04c86144.png";